<!-- <div class="dynamic-field form-select" [formGroup]="group">
<label>{{ config.label }}</label>
<select [formControlName]="config.name">
  <option value="">{{ config.placeholder }}</option>
  <option *ngFor="let option of config.options">
    {{ option }}
  </option>
</select>
</div> -->

@if (!config.hide && !config?.isAutoCompleteDropdown) {
  <mat-form-field [formGroup]="group" class="basic-select-dropdown mb-15" [ngClass]="config.class" appearance="outline">
    <mat-label class="select-label">{{config.label}}</mat-label>
    <select [placeholder]="config.placeholder" id="{{config.id}}" [formControlName]="config.name"  [attr.name]="config.name" disableOptionCentering= 'true' matNativeControl (change)="onChange($event.target.value)">
      <option selected [disabled]="iosSelectOptionDisable" value style="display:none">{{'select' | translate}}</option>
      @for (option of config.options; track option) {
        <option id="{{option | displayText}}" [value]="option.id">
          {{ option | displayText}}
        </option>
      }
    </select>
    @if (group.controls[FormControlName].hasError('required') && config.showErrorText) {
      <mat-error>
        Field Required
      </mat-error>
    }
  </mat-form-field>
}

@if (!config.hide && config?.isAutoCompleteDropdown) {
  <mat-form-field [formGroup]="group" class="basic-select-dropdown" [ngClass]="config.class" appearance="outline"
    >
    <mat-label>{{config.label}}</mat-label>
    <input autocomplete="off" matInput [formControlName]="config.name" id="{{config.id}}" [matAutocomplete]="auto">
    <mat-autocomplete #autocompleteTrigger #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" (optionSelected)="onChange($event)"
      (closed)="validInput($event)">
      @for (option of config.options; track option) {
        <mat-option [value]="option.id">
          {{ option.value }}
        </mat-option>
      }
      @if (config.options?.length === 0 && config?.searchText) {
        <mat-option class="caption-s">
          <span>{{ 'common.noDataFound' | translate}}</span>
        </mat-option>
      }
    </mat-autocomplete>
    @if (group.controls[FormControlName].hasError('required')) {
      <mat-error>
        {{ 'common.autoComplteError' | translate }}
      </mat-error>
    }
  </mat-form-field>
}